import { FC, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../_metronic/helpers";
import { useDataTableStore } from "../../stores/DataTableStore";
import Swal from "sweetalert2";
import useAccessToken from "../../hooks/AccessToken";
import { User, UserSession } from "../../interfaces/User";
import { Drawer } from 'rsuite'
import { useCompanyStore } from "../../stores/CompanyStore";
import { useIntl } from 'react-intl';
import { ListLinkDevice } from "../LinkDevice/ListLinkDevice";
import axios from "axios";
import useSWR from "swr";

interface Props {
    userData: User
    isOpen: boolean
    setIsOpen: (value: boolean) => void
}

const LinkDeviceUser: FC<Props> = ({ userData, isOpen, setIsOpen }) => {
    const API_URL = process.env.REACT_APP_API_URL
    const token = useAccessToken()
    const intl = useIntl()
    const [userSessions, setUserSessions] = useState<UserSession[]>([])

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)
    const { data = [], isLoading } = useSWR(`${API_URL}user-sessions?userId=${userData.id}`, fetcher, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    })

    useEffect(() => {
        if (!isLoading) {
            setUserSessions(data)
        }
    }, [data])

    return (
        <Drawer size='xs' open={isOpen} onClose={() => setIsOpen(false)}>
            <Drawer.Header>
                <Drawer.Title style={{ fontWeight: "500" }}>{intl.formatMessage({ id: "FORM.ACTION.LINKED_DEVICES" })} {userData.name}</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body style={{ padding: '30px 30px' }}>
                {
                    isLoading ?
                        <div className="loading-overlay">
                            <div className="loader"></div>
                        </div>
                        :
                        userSessions.map((data, index) => {
                            return <ListLinkDevice data={data} type={"masterUser"} setSessions={setUserSessions} />
                        })
                }
            </Drawer.Body>
        </Drawer>
    )
}

export { LinkDeviceUser }